"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.compareBy = void 0;
require("../../core");
const compareBy = (key, asc = true, locales, options) => (a, b) => {
    if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
        return 0;
    }
    const aValue = String(a[key]).toLowerCase();
    const bValue = String(b[key]).toLowerCase();
    const comparison = aValue.localeCompare(bValue, locales, Object.assign({ numeric: true, sensitivity: 'base' }, options));
    return !asc ? comparison * -1 : comparison;
};
exports.compareBy = compareBy;
//# sourceMappingURL=compareBy.js.map